import { Suspense, useState } from "react";
import { Box, CssBaseline, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Loader from "components/Loader";
import MainContainer from "./components/Container";
import Footer from "./components/Footer";

const drawerWidth = 260;

const AdminLayout = () => {
    const [open, setOpen] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <CssBaseline />
            <Header
                open={open}
                isMobile={isMobile}
                drawerWidth={drawerWidth}
            />

            <Box
                sx={{
                    display: "flex",
                    flex: 1,
                    minHeight: 0,
                }}
            >
                <Sidebar
                    setOpen={setOpen}
                    open={open}
                    isMobile={isMobile}
                    drawerWidth={drawerWidth}
                />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        padding: '24px 24px 0px 24px',
                        p: 3,
                        pb: 0,
                        mb: 3,
                        overflow: "auto",
                    }}
                >
                    <Toolbar />

                    <Suspense fallback={<Loader />}>
                        <MainContainer
                            open={open}
                            isMobile={isMobile}
                            drawerWidth={drawerWidth}
                        >
                            <Outlet />
                        </MainContainer>
                    </Suspense>
                </Box>
            </Box>

            <Footer
                open={open}
                isMobile={isMobile}
                drawerWidth={drawerWidth} />
        </Box>
    );
};

export default AdminLayout;
